import { Button, Pagination, Space, Table } from 'antd';
import { DeleteOutlined, DownloadOutlined } from '@ant-design/icons';

const ContentTableSection = ({
  columns,
  dataSource,
  loading,
  rowSelection,
  pagination,
  selectedRowKeys,
  isAllCurrentPageSelected,
  toggleSelectAllCurrentPage,
  normalizeContentType,
  selectedTypeById,
  handleBatchDownload,
  handleBatchDelete,
  clearSelection,
  onPageChange,
  onPageSizeChange,
}) => (
  <>
    <div className="page-panel__body">
      <Table
        columns={columns}
        dataSource={dataSource}
        rowKey="content_id"
        loading={loading}
        scroll={{ x: 1200 }}
        rowSelection={rowSelection}
        pagination={false}
      />
    </div>

    <div className="page-panel__bottom" style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '12px 16px 0',
      background: '#fff',
    }}
    >
      <div>
        {selectedRowKeys.length > 0 && (
          <Space>
            <Button onClick={toggleSelectAllCurrentPage}>
              {isAllCurrentPageSelected ? '取消全选(本页)' : '全选本页'}
            </Button>
            <span>已选择 {selectedRowKeys.length} 项</span>
            {!selectedRowKeys.some((id) => {
              const t = normalizeContentType(selectedTypeById?.[id]);
              return t === '图文' || t === '笔记';
            }) && (
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={handleBatchDownload}
              >
                批量下载
              </Button>
            )}
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={handleBatchDelete}
            >
              批量删除
            </Button>
            <Button onClick={clearSelection}>
              清空全部
            </Button>
          </Space>
        )}
      </div>

      <div>
        <Pagination
          current={pagination.current}
          pageSize={pagination.pageSize}
          total={pagination.total}
          showTotal={(total) => `共 ${total} 条记录`}
          showSizeChanger
          showQuickJumper
          style={{ margin: 0 }}
          onChange={onPageChange}
          onShowSizeChange={onPageSizeChange}
        />
      </div>
    </div>
  </>
);

export default ContentTableSection;
